import { ProfileBanner } from '@/app/components/ProfileBanner';
import LandingHeaderV2 from '@/modules/LandingHeaderV2';
import cx from 'classnames';
import dynamic from 'next/dynamic';
import React from 'react';

import Footer from 'modules/Footer';

// import LandingHeader from 'modules/LandingHeader';
import styles from './style.module.scss';

const CookieConsentPrompt = dynamic(() => import('@/app/components/CookieConsentPrompt'));

export const CMSContainer = ({
  children,
  shouldUpdateFooterStyles,
}: {
  children: React.ReactNode;
  shouldUpdateFooterStyles?: boolean;
}) => {
  return (
    <div className={styles.outsideContainer}>
      {/* <LandingHeader /> */}
      <LandingHeaderV2 />
      {children}
      <Footer className={cx(shouldUpdateFooterStyles && styles.footer)} />
      <CookieConsentPrompt />
      <ProfileBanner />
    </div>
  );
};

export default CMSContainer;
